export default __webpack_public_path__ + "static/palettte2-496daa22253827df13000b445ab02e34.jpg";